import React from "react";

import { Size } from "src/theme";

import Shimmer from "./Shimmer";

export const HeadingShimmer = () => (
  <Shimmer width="24rem" textSize={Size.XL} />
);
